import React from "react";
import { Link } from "react-router-dom";
import { Heading, Text, Button, Box } from "@chakra-ui/react";

const LandingPage = () => {
  return (
    <Box textAlign="center" mt="10" p={{ base: 4, md: 0 }}>
      <Heading
        as="h1"
        size="xl"
        className="about-title"
        style={{
          background: 'linear-gradient(60deg, #E27A47 35%, #4BB19D 55%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        Welcome to Axy
      </Heading>
      <Text fontSize="lg" mt="4" className="landing-paragraph" px={{ base: 4, md: 0 }}>
        Seamlessly browse conference events, build your personalized agenda, and stay ahead with personalized
        recommendations tailored to your interests. Whether you're attending talks or exploring job opportunities 
        on our dedicated job board, Axy ensures you make the most out of your conference experience.
      </Text>
      <Text fontSize="md" mt="8">
      </Text>
      <Link to="/register">
        <Button
          colorScheme="teal"
          size="md"
          mt="2"
          className="registration-button"
          sx={{
            padding: "8px 30px",
            border: "none",
            outline: "none",
            position: "relative",
            zIndex: 1,
            borderRadius: "5px",
            background: "linear-gradient(to right, #4BB19D, #E27A47)",
            cursor: "pointer",
            marginRight: "20px",
            fontSize: "20px",
            textDecoration: "none",
            color: "#fffcf0",
            overflow: "hidden",
            _before: {
              content: '""',
              position: "absolute",
              left: "1px",
              right: "1px",
              top: "1px",
              bottom: "1px",
              borderRadius: "4px",
              backgroundColor: "#05051d",
              zIndex: -1,
              transition: "200ms",
            },
            _hover: {
              color: "#ffffff",
              _before: {
                opacity: 0.1,
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
              },
              _after: {
                opacity: 1,
                color: "white",
                width: "100%",
              },
            },
            _after: {
              content: 'attr(data)',
              fontSize: "16px",
              background: "linear-gradient(to left, #4BB19D, #E27A47)",
              color: "transparent",
              borderRadius: "10px",
            },
          }}
        >
          Get started by registering
        </Button>
      </Link>
    </Box>
  );
};

export default LandingPage;
